import type { RouteRecordRaw } from 'vue-router';
import {
  REDIRECT_ROUTE_NAME,
  NOT_BOUND_CLIENT_ROUTE_NAME,
  NOT_FOUND_ROUTE_NAME,
} from '@/router/constants';

export const DEFAULT_LAYOUT = () => import('@/layout/default-layout.vue');

export const REDIRECT_MAIN: RouteRecordRaw = {
  path: '/redirect',
  name: 'redirectWrapper',
  component: DEFAULT_LAYOUT,
  meta: {
    requiresAuth: true,
    // hideInMenu: true, // @/hooks/permission中return了root.meta.hideInMenu为true的路由跳转，导致tab中重新加载失效
  },
  children: [
    {
      path: '/redirect/:path?/:name?',
      name: REDIRECT_ROUTE_NAME,
      component: () => import('@/views/redirect/index.vue'),
      meta: {
        requiresAuth: true,
        hideInMenu: true,
      },
    },
  ],
};

export const NOT_FOUND_ROUTE: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: NOT_FOUND_ROUTE_NAME,
  redirect: '/404',
};

export const Route404: RouteRecordRaw = {
  path: '/404',
  name: `P404`,
  component: DEFAULT_LAYOUT,
  redirect: '/404/index',
  children: [
    {
      path: 'index',
      name: '404',
      component: () => import('@/views/not-found/index.vue'),
    },
  ],
};

// 未绑定品牌方路由
export const NOT_BOUND_CLIENT_ROUTE: RouteRecordRaw = {
  path: '/not-bound-client',
  name: NOT_BOUND_CLIENT_ROUTE_NAME,
  component: () => import('@/views/not-found/not-bound-client.vue'),
};
